module.exports = __webpack_public_path__ + "img/videoextensionproc.3bbf4c42.svg";